import React, { useEffect, useState } from "react";
import '../../CSS/TablaHerramientas.css'
import {BsPlus} from "react-icons/bs";
import axios from 'axios';
import { IoArrowUndo } from "react-icons/io5";
import {URI} from '../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import moment from "moment/moment";
import ModalConfPagos from './ModalConfPagos';
import { getToken } from "../../Conexiones/Conexion";

function PagosOficina() {
    const navigate = useNavigate()
    const day = moment().isoWeekday()
    const [gastosOficina, setGastosOficina] = useState([])
    const [totalGasto, setTotalGasto] = useState(0)

    useEffect( ()=>{
        const getGastos = async () =>{
            const res = await axios.get(URI + 'getGastosPagos',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setGastosOficina(res.data)
        }
        getGastos()
    }, [navigate])

    const regresar = () => {
        navigate('/inicio/oficina')
    }

    useEffect(() => {
        const getTotal = async () => {
            const res = await axios.get(URI+'getTotalPagosOficina',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setTotalGasto(res.data[0].total);
        }
        getTotal();
    }, [navigate]);

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    
    const total = formato(totalGasto)

    return (
        <div className="tablaHerramientas">
        <ModalConfPagos />
        <div >
            <h3 className="text-uppercase mb-3 tituloGastos">CONTROL PAGOS DE OFICINA</h3>
            <IoArrowUndo title="REGRESAR" onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
        </div>
        
        <div className='divboton' style={{margin:'5px 0'}}>                                                                                             
            <div className='boton' style={{display:'flex', justifyContent:'space-between'}} >
                    {day !== 7 ? (
                    <button title='REGISTRAR PAGOS' style={{justifyContent:'center'}} className="btn btn-light btncolor" data-bs-toggle="modal" data-bs-target="#modal-pagos-ofi" type="button">
                        <label className="agregar">REGISTRAR PAGOS</label><BsPlus style={{fontSize:'25px'}}/>
                    </button>
                ):(
                    <button title='REGISTRAR PAGOS' style={{justifyContent:'center'}} className="btn btn-light btncolor" type="button" disabled>
                        <label className="agregar">REGISTRAR PAGOS</label><BsPlus style={{fontSize:'25px'}}/>
                    </button>
                )}
                <input className="form-control" style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>
            </div>
        </div>
        <div className='divboton mb-2' style={{textAlign:'right'}}>
                        <div>
                            <strong><h5>{"TOTAL: $"+total}</h5></strong>
                        </div>
        </div>
        { gastosOficina.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
            <div className="caja-asistencia" >
                <div className="table tabla">
                    <table className="table  text-uppercase">
                        <thead >
                            <tr >
                                <th>CODIGO</th>
                                <th>CONCEPTO</th>
                                <th>DIAS</th>
                                <th>PRECIO</th>
                                <th>TOTAL</th>
                                <th>EXTRA</th>
                                <th>FECHA</th>
                                <th>POR SEMANA</th>
                            </tr>
                        </thead>
                        <tbody >
                            {gastosOficina.map(g =>{
                                return(
                                    g.totalSemana === 0 ? (
                                        <tr key={g.idEmpleado + g.fecha}>
                                        <td>{g.codigoEmp}</td>
                                        <td>{g.nombreEmp}{' '}{g.apellidoPaternoEmp}{' '}{g.apellidoMaternoEmp}</td>
                                        <td>{g.dias}</td>
                                        <td>$ {g.precio}</td>
                                        <td>$ {g.total}</td>
                                        <td>$ {g.extra}</td>
                                        <td>{moment(g.fecha).format("DD-MM-YYYY")}</td>
                                        <td>{g.totalSemana}</td>
                                    </tr>
                                    ):(
                                        <tr key={g.idEmpleado + g.fecha} style={{borderBottomColor:'black'}}>
                                        <td>{g.codigoEmp}</td>
                                        <td>{g.nombreEmp}{' '}{g.apellidoPaternoEmp}{' '}{g.apellidoMaternoEmp}</td>
                                        <td>{g.dias}</td>
                                        <td>$ {g.precio}</td>
                                        <td>$ {g.total}</td>
                                        <td>$ {g.extra}</td>
                                        <td>{moment(g.fecha).format("DD-MM-YYYY")}</td>
                                        <td>{g.totalSemana}</td>
                                    </tr>
                                    )
                                )
                            })}
                        </tbody>
                    </table>
                </div>           
            </div>
                )}
    </div>
    );
}

export default PagosOficina;